import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv2310SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv2310SearchParams = z.infer<typeof Inv2310SearchParamsSchema>

export const Inv2310SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Inv2310SearchResultModel = z.infer<
  typeof Inv2310SearchResultModelSchema
>

export const Inv2310SearchResultSchema = z
  .object({
    data: z.array(Inv2310SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv2310SearchResult = z.infer<typeof Inv2310SearchResultSchema>
